import React, { useState, useEffect } from "react";
import { Table, Button, Space, Popconfirm, message } from "antd";
import {
  collection,
  getDocs,
  query,
  where,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase/firebase"; // Adjust the import path as needed
import { getAuth, createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";

const Candidates = () => {
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch candidates data from Firestore
  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        setLoading(true);
        const candidatesQuery = query(collection(db, "candidates"));
        const candidatesSnapshot = await getDocs(candidatesQuery);
        const candidatesList = candidatesSnapshot.docs.map((doc) => ({
          key: doc.id,
          ...doc.data(),
        }));
        setCandidates(candidatesList);
      } catch (error) {
        /*console.error("Error fetching candidates:", error);*/
        message.error("Failed to load candidates.");
      } finally {
        setLoading(false);
      }
    };
    fetchCandidates();
  }, []);

  // Handle sending email to a candidate
  const handleSendEmail = async (candidate) => {
    try {
      // Check if candidate email exists
      if (!candidate.email) {
        message.error("Cannot send email: Candidate email is missing");
        return;
      }
      
      const auth = getAuth();
      
      // Since you already have uid in candidate, no need to create a new user
      // Just send password reset email directly
      await sendPasswordResetEmail(auth, candidate.email);
  
      // Update the candidate's emailSent status in Firestore
      await updateDoc(doc(db, "candidates", candidate.key), {
        emailSent: 1,
        lastEmailSent: new Date().toISOString()
      });
  
      // Update local state to reflect the change
      setCandidates((prev) =>
        prev.map((c) =>
          c.key === candidate.key
            ? { 
                ...c, 
                emailSent: 1,
                lastEmailSent: new Date().toISOString()
              }
            : c
        )
      );
  
      message.success(`Password reset email sent to ${candidate.name} successfully.`);
    } catch (error) {
      /*console.error("Error sending email:", error);*/
      
      // Handle specific Firebase Auth errors
      if (error.code === 'auth/user-not-found') {
        message.error("No user found with this email address. Please ensure the candidate is registered in Firebase Authentication.");
      } else {
        message.error(`Failed to send email: ${error.message}`);
      }
    }
  };

  // Define table columns
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Medecin Type",
      dataIndex: "role",
      key: "role",
      render: (role) => role || "N/A",
    },
    {
      title: "Address",
      key: "address",
      render: (_, record) => {
        const country = record.country || ''||record.address;
        return country ? country : "N/A";
      },
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      render: (phoneNumber) => phoneNumber || "N/A",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Popconfirm
            title={`Are you sure you want to send an email to ${record.name}?`}
            onConfirm={() => handleSendEmail(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary">Send Email</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <h2>Candidates List</h2>
      <Table
        dataSource={candidates}
        columns={columns}
        rowKey="key"
        loading={loading}
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};

export default Candidates;